import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['multipleToggle', 'singleDayInputs', 'multipleDaysInputs', 'selectedDates', 'multipleDatesInput', 'dailyStartTime', 'dailyEndTime', 'form']

  connect() {
    // 初始化表单状态
    if (this.hasMultipleToggleTarget) {
      this.updateFormVisibility()
    }
  }

  toggleMultipleDays() {
    this.updateFormVisibility()
  }

  updateFormVisibility() {
    if (!this.hasMultipleToggleTarget) return
    
    const isMultiple = this.multipleToggleTarget.checked

    if (isMultiple) {
      this.singleDayInputsTarget.style.display = 'none'
      this.multipleDaysInputsTarget.style.display = 'block'
    } else {
      this.singleDayInputsTarget.style.display = 'block'
      this.multipleDaysInputsTarget.style.display = 'none'
    }
  }

  submitForm(event) {
    // 处理多天课程表单提交
    if (this.hasMultipleToggleTarget && !this.multipleToggleTarget.checked) {
      // 单天课程，正常提交
      return
    }

    // 阻止默认提交
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    if (event && event.detail && event.detail.formSubmission) {
      event.detail.formSubmission.stop()
    }

    // 验证并处理多天课程数据
    const selectedDates = this.selectedDatesTarget.value
    if (!selectedDates) {
      alert('请选择至少一个日期')
      return false
    }

    const startTime = this.dailyStartTimeTarget.value
    const endTime = this.dailyEndTimeTarget.value

    if (!startTime || !endTime) {
      alert('请设置开始和结束时间')
      return false
    }

    const dates = selectedDates.split(',').map(date => date.trim())
    const formattedDates = dates.map(date => {
      return {
        date: date,
        start_time: startTime,
        end_time: endTime
      }
    })

    this.multipleDatesInputTarget.value = JSON.stringify(formattedDates)
    console.log('提交多天课程表单', this.multipleDatesInputTarget.value)
    
    // 提交表单
    if (typeof this.formTarget.requestSubmit === 'function') {
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.submit()
    }
  }
}
